"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.container = void 0;
require("reflect-metadata");
var inversify_1 = require("inversify");
var api_gateway_1 = require("./api-gateway");
var api_gateway_types_1 = require("./api-gateway.types");
var container = new inversify_1.ContainerModule(function (bind) {
    bind(api_gateway_types_1.TYPES.ApiGateway)
        .to(api_gateway_1.ApiGateway)
        .inSingletonScope();
});
exports.container = container;
//# sourceMappingURL=api-gateway.bootstrap.js.map